<template>
  <div class="box" v-if="player">
    <transactions-list :data-func="getTransactions" :show-user="false"/>
  </div>
</template>
<script>
  import state from '../../../../state'
  import playerService from '../../../../services/player.service'
  import transactionService from '../../../../services/transaction.service'
  import balanceService from '../../../../services/balance.service'
  import currencyService from '../../../../services/currency.service'

  import description from '../../../common/description.vue'
  import transactionsList from '../../../common/transactions-list.vue'

  import { required, minValue } from 'vuelidate/lib/validators'

  export default {
    name: 'player-transactions',
    components: { description, transactionsList },
    data() {
      return {
        targetBalance: null,
        transferAmount: 0
      }
    },
    computed: {
      playerId() {
        return this.$route.params.playerId;
      },
      player() {
        return state.editPlayer.get();
      }
    },
    validations: {
      targetBalance: {
        required
      },
      transferAmount: {
        required,
        minValue: minValue(0.01)
      }
    },
    async mounted() {
      await playerService.load(this.playerId);
    },
    methods: {
      async getTransactions(filter) {
        filter.userId = this.playerId;
        return await transactionService.get(filter);
      },
      async deposit() {
        await this.transfer(balanceService.depositUser);
      },
      async withdraw() {
        await this.transfer(balanceService.withdrawUser);
      },
      async transfer(transferFunc) {
        await transferFunc(this.targetBalance.id, await this.getSourceTransferAmount());
        await this.loadTransactions();
        this.targetBalance = null;
        this.transferAmount = 0;
      },
      getSourceTransferAmount() {
        return this.targetBalance ? currencyService.toSource(this.transferAmount, this.targetBalance.currency) : 0;
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/client/players/player/transactions.vue